var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-loading"}),_c('router-view'),_c('div',{staticClass:"loading-for-commands"},[_c('Loader',{attrs:{"visible":_vm.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }